// Name / Email / Phone section
export default function PersonalInfoSection({ form, setField }) {
	return (
		<div>
			<h3 className="text-lg font-semibold text-gray-900 mb-6">Personal Information</h3>

			<div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
				<div className="lg:col-span-1">
					<label htmlFor="customerName" className="block text-sm font-medium text-gray-700 mb-2">
						Full Name <span className="text-red-500">*</span>
					</label>
					<input
						id="customerName"
						name="customerName"
						type="text"
						value={form.customerName}
						onChange={e => setField('customerName', e.target.value)}
						required
						autoComplete="name"
						placeholder="Enter full name"
						className="block w-full rounded-lg border-0 py-2.5 px-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 sm:text-sm transition-colors"
					/>
				</div>

				<div className="lg:col-span-1">
					<label htmlFor="customerEmail" className="block text-sm font-medium text-gray-700 mb-2">
						Email Address
					</label>
					<input
						id="customerEmail"
						name="customerEmail"
						type="email"
						value={form.customerEmail}
						onChange={e => setField('customerEmail', e.target.value)}
						autoComplete="email"
						placeholder="example@email.com"
						className="block w-full rounded-lg border-0 py-2.5 px-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 sm:text-sm transition-colors"
					/>
				</div>

				<div className="lg:col-span-1">
					<label htmlFor="customerTel" className="block text-sm font-medium text-gray-700 mb-2">
						Phone Number
					</label>
					<input
						id="customerTel"
						name="customerTel"
						type="tel"
						value={form.customerTel}
						onChange={e => setField('customerTel', e.target.value)}
						autoComplete="tel"
						placeholder="+971 50 123 4567"
						className="block w-full rounded-lg border-0 py-2.5 px-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 sm:text-sm transition-colors"
					/>
				</div>
			</div>
		</div>
	)
}
